import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import { apiRoot, db } from "../../index";
import { UserContext } from "../../App";
import {
  sendInvoiceEmail,
  markInvoiceAsPaid,
  deleteInvoicesFromInvoiceIdList,
  checkInvoicesExistOnStripe,
} from "../../store/actions/estimateActions";
import ActionsMenu from "../layout/ActionsMenu";
import { NavItem, NavTabs } from "../layout/Nav";
import { verifyRight } from "../../utils/users";
import TrashIcon from "../icons/TrashIcon";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import { StyledTr } from "./bookingContent";
import { OutlineButtonLink } from "../layout/OutlineButton";
import axios from "axios";
import SelectContactsModal from "../../utils/estimate-invoice/SelectContactsModal";
import { FiFilter } from "react-icons/fi";
import { Button, Form, Modal } from "react-bootstrap";

export const invoiceStatus = {
  draft: "Brouillon",
  open: "A envoyer",
  sent: "Envoyé",
  paid: "Payé",
  canceled: "Annulé",
};

const invoiceStatusOrder = {
  draft: 0,
  open: 1,
  sent: 2,
  paid: 3,
  canceled: 4,
};

// Status Filter Modal Component
function StatusFilterModal({ show, setShow, filter, setFilter }) {
  function updateFilter(value) {
    setFilter(value);
  }

  return (
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Filtrer par statut</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="statusFilter">
            <Form.Label>Statut</Form.Label>
            <Form.Control
              as="select"
              value={filter}
              onChange={(e) => updateFilter(e.target.value)}
            >
              <option value="">Tout</option>
              {Object.entries(invoiceStatus).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default function InvoiceContent(props) {
  const { userInfos, loading } = useContext(UserContext);
  const [invoiceList, setInvoiceList] = useState([]);

  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [showContactsModal, setShowContactsModal] = useState(false);
  const [currentInvoice, setCurrentInvoice] = useState(null);
  const [isSending, setIsSending] = useState(false);

  // Status filter state
  const [showStatusFilterModal, setShowStatusFilterModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");

  const init = useRef(false);
  const datatable = useRef(null);

  // Function to update the filter
  const updateFilter = useCallback(() => {
    if (!datatable.current) return;
    const regexCorresp = {
      draft: /Brouillon/,
      open: /A envoyer/i,
      sent: /Envoyé/i,
      paid: /Payé/i,
      canceled: /Annulé/i,
    }

    if (statusFilter && regexCorresp[statusFilter]) {
      datatable.current.column(3).search(regexCorresp[statusFilter], true, false).draw();
    } else {
      datatable.current.column(3).search("").draw();
    }
  }, [statusFilter]);

  useEffect(() => {
    if (invoiceList.length > 0) {
      datatable.current = $("#estimate-datatable").DataTable({
        order: [[6, "desc"]],
        pageLength: 25,
        sortable: true,
      });

      datatable.current.draw();
    }
  }, [invoiceList]);

  // Apply filter when statusFilter changes
  useEffect(() => {
    updateFilter();
  }, [statusFilter, updateFilter]);

  const initData = useCallback(() => {
    if (
      !loading &&
      userInfos &&
      userInfos.jwt &&
      userInfos.uid &&
      !init.current
    ) {
      // load estimates from the firebase db
      db.ref("users/" + userInfos.uid + "/invoices").once(
        "value",
        (snapshot) => {
          let data = snapshot.val();
          if (!data) data = [];
          setInvoiceList(
            Object.keys(data).map((k) => {
              return {
                ...data[k],
                id: k,
              };
            })
          );
          init.current = true;
        }
      );
    }
  }, [loading, userInfos]);

  useEffect(() => {
    initData();
  }, [initData]);

  const deleteInvoiceListClick = useCallback(async () => {
    // Check existence on Stripe first
    const checkResponse = await checkInvoicesExistOnStripe(selectedInvoices, userInfos.jwt);
    const stripeChecks = checkResponse.data;
    
    // Create a map for quick lookup
    const stripeCheckMap = {};
    stripeChecks.forEach(check => {
      stripeCheckMap[check.invoiceId] = check.existsOnStripe;
    });
    
    // Get selected invoices details
    const selectedInvoicesData = invoiceList.filter(inv => selectedInvoices.includes(inv.id));
    const invoiceStatuses = selectedInvoicesData.map(inv => {
      const statusLabel = inv.status === "draft" ? "brouillon" : 
                         inv.status === "open" ? "ouverte" :
                         inv.status === "sent" ? "envoyée" :
                         inv.status === "paid" ? "payée" : inv.status;
      const existsOnStripe = stripeCheckMap[inv.id];
      const stripeStatus = existsOnStripe ? "" : " - n'existe pas sur Stripe";
      return `- ${inv.id} (${statusLabel}${stripeStatus})`;
    }).join("\n");
    
    if (!window.confirm(
      `Êtes-vous sûr de vouloir supprimer ces factures ?\n\n${invoiceStatuses}`
    ))
      return;
    
    const response = await deleteInvoicesFromInvoiceIdList(selectedInvoices, userInfos.jwt);
    const results = response.data;
    
    // Prepare detailed message
    const successMessages = results.filter(r => r && r.success).map(r => r.message);
    const errorMessages = results.filter(r => r && !r.success).map(r => r.message);
    
    let message = "";
    if (successMessages.length > 0) {
      message += successMessages.join("\n");
    }
    if (errorMessages.length > 0) {
      if (message) message += "\n\n";
      message += "Erreurs :\n" + errorMessages.join("\n");
    }
    
    window.alert(message || "Opération terminée");
    window.location.reload();
  }, [selectedInvoices, userInfos.jwt, invoiceList]);

  const toggleSelected = useCallback((id) => {
    setSelectedInvoices((_selectedEstimates) => {
      if (_selectedEstimates.indexOf(id) !== -1) {
        return _selectedEstimates.filter((e) => e !== id);
      } else {
        return [..._selectedEstimates, id];
      }
    });
  }, []);

  // This function doesn't rely on state, so it can be called immediately
  const sendInvoiceEmailDirectly = useCallback(
    async (invoice, selectedContacts) => {
      setIsSending(true);
      try {
        await sendInvoiceEmail(invoice.id, userInfos.jwt, selectedContacts);
        window.alert("Facture envoyée avec succès");
        window.location.reload();
      } catch (error) {
        console.error("Error sending email:", error);
        window.alert("Erreur lors de l'envoi de l'email");
      } finally {
        setIsSending(false);
      }
    },
    [userInfos.jwt]
  );

  const handleSendEmail = useCallback(
    async (selectedContacts) => {
      if (!currentInvoice) return;

      await sendInvoiceEmailDirectly(currentInvoice, selectedContacts);
      setShowContactsModal(false);
    },
    [currentInvoice, sendInvoiceEmailDirectly]
  );

  const tableBody = useMemo(() => {
    return invoiceList.map((invoice) => {
      let actions = [];

      if (verifyRight(userInfos, "invoice", "update")) {
        actions.push({
          label: "Modifier",
          link: "/invoices/" + invoice.id + "/",
        });
      }

      if (invoice.status !== "draft") {
        if (verifyRight(userInfos, "invoice", "read")) {
          actions.push({
            label: "Page de paiement",
            externalLink: true,
            asyncLink: async () => {
              try {
                let response = await axios.post(
                  apiRoot + "/api/v1/invoice/get-payment-link",
                  {
                    invoiceId: invoice.id,
                  },
                  {
                    headers: {
                      Authorization: userInfos.jwt,
                    },
                  }
                );

                return response.data;
              } catch (error) {
                console.error("Error getting payment link:", error);
                const errorMessage = error.response?.data || "Erreur lors de la récupération du lien de paiement";
                window.alert(`Erreur: ${errorMessage}`);
                throw error; // Re-throw to prevent opening the link
              }
            },
          });
        }
      }

      if (invoice.status !== "paid" && invoice.status !== "canceled") {
        if (verifyRight(userInfos, "invoice", "update"))
          actions.push({
            label: "Envoyer la facture",
            onClick: () => {
              // Check if the customer has contacts before showing the modal
              db.ref(
                `users/${userInfos.uid}/provider/${invoice.customer.id}`
              ).once("value", (snapshot) => {
                const providerData = snapshot.val();
                if (
                  providerData &&
                  providerData.contacts &&
                  providerData.contacts.length > 0
                ) {
                  setCurrentInvoice(invoice);
                  setShowContactsModal(true);
                } else {
                  // If no contacts, use the direct function that doesn't rely on state
                  sendInvoiceEmailDirectly(invoice, []);
                }
              });
            },
          });
      }

      if (invoice.status !== "paid" && invoice.status !== "canceled") {
        if (verifyRight(userInfos, "invoice", "update"))
          actions.push({
            label: "Marquer comme payé",
            onClick: async () => {
              if (
                !window.confirm(
                  "Etes-vous sûr de vouloir marquer cette facture comme payée ?"
                )
              )
                return;

              try {
                await markInvoiceAsPaid(invoice.id, userInfos.jwt);
                window.alert("Facture marquée comme payée avec succès");
                window.location.reload();
              } catch (error) {
                const apiError =
                  typeof error?.response?.data === "string"
                    ? error.response.data
                    : error?.response?.data?.error ||
                      error?.response?.data?.message ||
                      "";
                if (!apiError) {
                  window.alert(
                    "Erreur lors du marquage de la facture comme payée. Veuillez réessayer."
                  );
                }
              }
            },
          });
      }

      actions.push({ divider: true });

      if (verifyRight(userInfos, "invoice", "delete")) {
        actions.push({
          label: "Delete",
          disabled: false,
          onClick: async () => {
            // Check existence on Stripe first
            const checkResponse = await checkInvoicesExistOnStripe([invoice.id], userInfos.jwt);
            const stripeCheck = checkResponse.data[0];
            
            const statusLabel = invoice.status === "draft" ? "brouillon" : 
                               invoice.status === "open" ? "ouverte" :
                               invoice.status === "sent" ? "envoyée" :
                               invoice.status === "paid" ? "payée" : invoice.status;
            const stripeStatus = stripeCheck.existsOnStripe ? "" : " - n'existe pas sur Stripe";
            
            if (
              !window.confirm(
                `Êtes-vous sûr de vouloir supprimer cette facture ?\n\nFacture: ${invoice.id}\nStatut: ${statusLabel}${stripeStatus}`
              )
            )
              return;
            
            const response = await deleteInvoicesFromInvoiceIdList(
              [invoice.id],
              userInfos.jwt
            );
            const results = response.data;
            const result = results[0];
            
            if (result && result.success) {
              window.alert(result.message);
            } else if (result && !result.success) {
              window.alert(result.message);
            } else {
              window.alert("Facture supprimée avec succès");
            }
            window.location.reload();
          },
        });
      }

      actions.push({ divider: true });
      if (invoice.estimate) {
        if (verifyRight(userInfos, "estimate", "read"))
          actions.push({
            label: "Voir le devis",
            link: "/estimates/" + invoice.estimate,
          });
      }

      return (
        <StyledTr
          key={invoice.id}
          className={
            selectedInvoices.indexOf(invoice.id) !== -1 ? "checked" : ""
          }
        >
          <td>
            <input
              type="checkbox"
              checked={selectedInvoices.indexOf(invoice.id) !== -1}
              onChange={() => toggleSelected(invoice.id)}
            />
          </td>
          <td>{invoice.id}</td>
          <td>
            {invoice.customer.firstname + " " + invoice.customer.lastname}
          </td>
          <td data-sort={invoiceStatusOrder[invoice.status]}>
            {invoiceStatus[invoice.status]}
          </td>
          <td>{parseFloat(invoice.price).toFixed(2)} €</td>
          <td>{invoice.bookingsCreated ? "Yes" : "No"}</td>
          <td data-order={invoice.createdAt}>
            {moment((invoice.createdAt || 0) * 1000).format("DD MMM YYYY")}
          </td>
          <td data-order={invoice.emittedAt || (["open", "sent", "paid", "cancelled"].indexOf(invoice.status) !== -1 ? 0 : Number.MAX_SAFE_INTEGER)}>
            {invoice.emittedAt
              ? moment(invoice.emittedAt * 1000).format("DD MMM YYYY")
              : "N/A"}
          </td>
          <td data-order={invoice.dueAt || (["open", "sent", "paid", "cancelled"].indexOf(invoice.status) !== -1 ? 0 : Number.MAX_SAFE_INTEGER)}>
            {invoice.dueAt
              ? moment(invoice.dueAt * 1000).format("DD MMM YYYY")
              : "N/A"}
          </td>
          <td data-order={invoice.paidAt || (["paid", "cancelled"].indexOf(invoice.status) !== -1 ? 0 : Number.MAX_SAFE_INTEGER)}>
            {invoice.paidAt
              ? moment(invoice.paidAt * 1000).format("DD MMM YYYY")
              : "N/A"}
          </td>
          <td>
            <ActionsMenu items={actions} />
          </td>
        </StyledTr>
      );
    });
  }, [invoiceList, selectedInvoices, sendInvoiceEmailDirectly, toggleSelected, userInfos]);

  const Footer = useMemo(() => {
    if (selectedInvoices.length === 0) return null;
    let actions = [];

    if (verifyRight(userInfos, "invoice", "delete")) {
      // Allow deletion attempt - backend will check if it's possible
      actions.push({
        label: <TrashIcon />,
        title: "Supprimer",
        onClick: deleteInvoiceListClick,
        disabled: false,
      });
    }

    return (
      <SelectionActionsPopup
        buttons={actions}
        items={[]}
        resetChecked={() => setSelectedInvoices([])}
        selectedItemsLength={selectedInvoices.length}
      />
    );
  }, [deleteInvoiceListClick, selectedInvoices.length, userInfos]);

  if (!userInfos) return null;
  return (
    <div className="body-container">
      <div className="title-container">
        <NavTabs className="titles">
          {verifyRight(userInfos, "estimate", "read") && (
            <NavItem>
              <Link to="/estimates">Devis</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "invoice", "read") && (
            <NavItem className="active">
              <Link to="/invoices">Factures</Link>
            </NavItem>
          )}
        </NavTabs>
        <div className="header-toolbar">
          <button
            onClick={() => setShowStatusFilterModal(true)}
            className="btn-custom mr-2"
          >
            <FiFilter size={24} />
          </button>
          {verifyRight(userInfos, "invoice", "create") && (
            <OutlineButtonLink to="/addInvoice/">
              <i className="la la-plus"></i>
              Nouvelle facture
            </OutlineButtonLink>
          )}
        </div>
      </div>
      <div className="kt-portlet__body">
        <div>
          <table
            className="table table-striped- table-bordered table-hover table-checkable"
            id="estimate-datatable"
          >
            <thead>
              <tr>
                <th style={{ width: "1%" }}></th>
                <th style={{ width: "5%" }}>ID</th>
                <th style={{ width: "15%" }}>Client</th>
                <th style={{ width: "5%" }}>Statut</th>
                <th style={{ width: "5%" }}>Total TTC</th>
                <th style={{ width: "5%" }}>Courses créées ?</th>
                <th style={{ width: "5%" }}>Date création</th>
                <th style={{ width: "5%" }}>Date émission</th>
                <th style={{ width: "5%" }}>Date échéance</th>
                <th style={{ width: "5%" }}>Date paiement</th>
                <th style={{ width: "2%" }}>Actions</th>
              </tr>
            </thead>
            <tbody>{tableBody}</tbody>
          </table>
        </div>
        {Footer}
      </div>

      <SelectContactsModal
        show={showContactsModal}
        setShow={setShowContactsModal}
        invoice={currentInvoice}
        submit={handleSendEmail}
        fetching={isSending}
      />

      <StatusFilterModal
        show={showStatusFilterModal}
        setShow={setShowStatusFilterModal}
        filter={statusFilter}
        setFilter={setStatusFilter}
      />
    </div>
  );
}
